import React from 'react';
import * as S from './CloseButton.styles';

/**
 * A real close button: the app's own cross asset inside a `<button>` with an accessible name.
 *
 * Round 2 of task 001. The two version-history panels rendered a literal lowercase letter `x` in a
 * bare button, and the shared `Modal`'s cross is a styled SVG with a click handler and no
 * accessible name — so neither was both themed and announceable. This is, and it can be reused
 * anywhere a panel needs its own close affordance.
 */
export const CloseButton: React.FC<{
  onClick: () => void;
  ariaLabel: string;
  dataCy?: string;
}> = ({ onClick, ariaLabel, dataCy = 'close-button' }) => (
  <S.Button type="button" onClick={onClick} aria-label={ariaLabel} data-cy={dataCy}>
    <S.Icon />
  </S.Button>
);
